import usePromotionEventStore from "../store/usePromotionEventStore"
import {
  PROMOTION_EVENT_POPUP_CONFIG,
  getPromotionEnvFromRoot,
  resolvePromotionEventCode,
} from "../EventConfig"

/**
 * 프로모션 이벤트 헤더 생성
 * - 인자 없음: 스토어의 모든 이벤트 사용
 * - 인자 있음: 지정한 이벤트 코드들 사용 (복수 가능)
 *
 * @example
 * getPromotionEventHeaders()             // 스토어 이벤트 → { "X-RL-Event": "418, 419" }
 * getPromotionEventHeaders("418", "419") // 복수 이벤트 → { "X-RL-Event": "418, 419" }
 */
export const getPromotionEventHeaders = (
  ...eventCodes: string[]
): Record<string, string> => {
  const env = getPromotionEnvFromRoot(process.env.NEXT_PUBLIC_ROOT)
  const mapEventCodeForHeader = (code: string) => {
    // 스토어/인자로 들어온 alias를 canonical 코드로 맞춘 뒤 환경별 헤더 코드로 변환한다.
    const eventCode = resolvePromotionEventCode(code)
    const config = PROMOTION_EVENT_POPUP_CONFIG[eventCode]
    const mapped = env ? config?.headerEventCodeByEnv?.[env] : undefined
    return mapped ?? eventCode
  }

  // 인자가 있으면 인자로 전달된 이벤트 코드 사용
  if (eventCodes.length > 0) {
    return { "X-RL-Event": eventCodes.map(mapEventCodeForHeader).join(", ") }
  }

  // 인자가 없으면 스토어에서 이벤트 배열 읽기
  const store = usePromotionEventStore.getState()
  store.clearExpiredEvents()

  const events = store.getEvents()
  if (events.length > 0) {
    return { "X-RL-Event": events.map(mapEventCodeForHeader).join(", ") }
  }

  return {}
}
